import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { CheckboxFieldComponent } from '../checkbox-field/checkbox-field.component';
import { InputDisplay } from '../input-group/input-group.properties';

@Component({
  selector: 'shared-ui-inputs-checkbox-group',
  templateUrl: './checkbox-group.component.html',
  styleUrls: ['./checkbox-group.component.css'],
  standalone: false,
})
export class CheckboxGroupComponent extends CheckboxFieldComponent implements OnInit {
  @Input() display = InputDisplay.Block;
  @Input() tooltip: TemplateRef<unknown> | null = null;

  constructor() {
    super();
  }

  ngOnInit(): void {}

  isInline(): boolean {
    return this.display === InputDisplay.Inline || this.isJustified();
  }

  isInlineOnly(): boolean {
    return this.display === InputDisplay.Inline;
  }

  isJustified(): boolean {
    return this.display === InputDisplay.InlineSpaced;
  }
}
